var urlToImgReg = new RegExp("{Url:(.*?),FileName:.*(png|jpeg|gif|bmp|jpg|ico)?UrlEnd:UrlEnd}", "ig")
var onlyImgReg = new RegExp("^{Url:(.*?),FileName:.*(png|jpeg|gif|bmp|jpg|ico)?UrlEnd:UrlEnd}$", "ig")
var urlToLinkAndExt = new RegExp("{Url:(.*?),FileName:(.*?),ThumbUrl:.*?UrlEnd:UrlEnd}", "ig")
var hrefLink = /href=['"](http.*?)['"]/ig;
var emotionReg = new RegExp("(\[:[a-z]+\])", "ig")
var reg = /\[:[a-z]+\]/g;

var imgTypes = [".PNG", ".JPEG", ".GIF", ".BMP", ".JPG", ".ICO"];

var fileTypes = {
  ".TXT": "txt.png",
  ".PDF": "pdf.png",
  ".DOC": "doc.png",
  ".DOCX": "docx.png",
  ".PPT": "ppt.png",
  ".PPTX": "ppt.png",
  ".XLS": "xls.png",
  ".XLSX": "xlsx.png"
};

var emotions = [{
  "fileName": "1.gif",
  "code": "[:wx]",
  "discprion": "\u5fae\u7b11"
}, {
  "fileName": "2.gif",
  "code": "[:se]",
  "discprion": "\u8272"
}, {
  "fileName": "3.gif",
  "code": "[:dai]",
  "discprion": "\u5446"
}, {
  "fileName": "4.gif",
  "code": "[:djy]",
  "discprion": "\u5927\u91d1\u7259"
}, {
  "fileName": "5.gif",
  "code": "[:dk]",
  "discprion": "\u5927\u54ed"
}, {
  "fileName": "6.gif",
  "code": "[:hx1]",
  "discprion": "\u5bb3\u7f9e"
}, {
  "fileName": "7.gif",
  "code": "[:bz]",
  "discprion": "\u95ed\u5634"
}, {
  "fileName": "8.gif",
  "code": "[:kun]",
  "discprion": "\u56f0"
}, {
  "fileName": "9.gif",
  "code": "[:kuk]",
  "discprion": "\u54ed"
}, {
  "fileName": "10.gif",
  "code": "[:gg]",
  "discprion": "\u5c34\u5c2c"
}, {
  "fileName": "11.gif",
  "code": "[:fh]",
  "discprion": "\u53d1\u706b"
}, {
  "fileName": "12.gif",
  "code": "[:tp]",
  "discprion": "\u8c03\u76ae"
}, {
  "fileName": "13.gif",
  "code": "[:zy]",
  "discprion": "\u9f87\u7259"
}, {
  "fileName": "14.gif",
  "code": "[:jy]",
  "discprion": "\u60ca\u8bb6"
}, {
  "fileName": "15.gif",
  "code": "[:ng]",
  "discprion": "\u96be\u8fc7"
}, {
  "fileName": "16.gif",
  "code": "[:ku]",
  "discprion": "\u9177"
}, {
  "fileName": "17.gif",
  "code": "[:han]",
  "discprion": "\u6c57"
}, {
  "fileName": "18.gif",
  "code": "[:zk]",
  "discprion": "\u6293\u72c2"
}, {
  "fileName": "19.gif",
  "code": "[:tu]",
  "discprion": "\u5410"
}, {
  "fileName": "20.gif",
  "code": "[:tx]",
  "discprion": "\u5077\u7b11"
}, {
  "fileName": "21.gif",
  "code": "[:ka]",
  "discprion": "\u53ef\u7231"
}, {
  "fileName": "22.gif",
  "code": "[:by]",
  "discprion": "\u767d\u773c"
}, {
  "fileName": "23.gif",
  "code": "[:am]",
  "discprion": "\u50b2\u6162"
}, {
  "fileName": "24.gif",
  "code": "[:ts]",
  "discprion": "\u5410\u820c"
}, {
  "fileName": "25.gif",
  "code": "[:hk]",
  "discprion": "\u5f88\u56f0"
}, {
  "fileName": "26.gif",
  "code": "[:jk]",
  "discprion": "\u60ca\u6050"
}, {
  "fileName": "27.gif",
  "code": "[:lh]",
  "discprion": "\u6d41\u6c57"
}, {
  "fileName": "28.gif",
  "code": "[:dx]",
  "discprion": "\u5927\u7b11"
}, {
  "fileName": "29.gif",
  "code": "[:db]",
  "discprion": "\u5927\u5175"
}, {
  "fileName": "30.gif",
  "code": "[:fd]",
  "discprion": "\u594b\u6597"
}, {
  "fileName": "31.gif",
  "code": "[:dc]",
  "discprion": "\u5927\u5435"
}, {
  "fileName": "32.gif",
  "code": "[:yw]",
  "discprion": "\u7591\u95ee"
}, {
  "fileName": "33.gif",
  "code": "[:xu]",
  "discprion": "\u5618"
}, {
  "fileName": "34.gif",
  "code": "[:yun]",
  "discprion": "\u6655"
}, {
  "fileName": "35.gif",
  "code": "[:zk]",
  "discprion": "\u6293\u72c2"
}, {
  "fileName": "36.gif",
  "code": "[:pz]",
  "discprion": "\u6487\u5634"
}, {
  "fileName": "38.gif",
  "code": "[:qiao]",
  "discprion": "\u6572"
}, {
  "fileName": "39.gif",
  "code": "[:zj]",
  "discprion": "\u518d\u89c1"
}, {
  "fileName": "40.gif",
  "code": "[:ch]",
  "discprion": "\u64e6\u6c57"
}, {
  "fileName": "41.gif",
  "code": "[:kb]",
  "discprion": "\u62a0\u9f3b"
}, {
  "fileName": "42.gif",
  "code": "[:gz]",
  "discprion": "\u9f13\u638c"
}, {
  "fileName": "43.gif",
  "code": "[:qiu]",
  "discprion": "\u7cd7"
}, {
  "fileName": "44.gif",
  "code": "[:hx]",
  "discprion": "\u574f\u7b11"
}, {
  "fileName": "45.gif",
  "code": "[:zxx]",
  "discprion": "\u5de6\u5618\u5618"
}, {
  "fileName": "46.gif",
  "code": "[:yxx]",
  "discprion": "\u53f3\u5618\u5618"
}, {
  "fileName": "47.gif",
  "code": "[:hq]",
  "discprion": "\u54c8\u6b20"
}, {
  "fileName": "48.gif",
  "code": "[:bs]",
  "discprion": "\u9119\u89c6"
}, {
  "fileName": "49.gif",
  "code": "[:wq]",
  "discprion": "\u59d4\u5c48"
}, {
  "fileName": "50.gif",
  "code": "[:kkl]",
  "discprion": "\u5feb\u54ed\u4e86"
}, {
  "fileName": "51.gif",
  "code": "[:yx]",
  "discprion": "\u9634\u9669"
}, {
  "fileName": "52.gif",
  "code": "[:qq]",
  "discprion": "\u4eb2\u4eb2"
}, {
  "fileName": "53.gif",
  "code": "[:xia]",
  "discprion": "\u5413"
}, {
  "fileName": "54.gif",
  "code": "[:kll]",
  "discprion": "\u53ef\u601c"
}];

class Util {
  constructor() {
    var gid = localStorage.getItem("deviceId")
    this.id = gid || this.guid();
    this.imgOnly = {}
  }

  getGuid() {
    return this.id;
  }

  guid() {
    var str = 'xxxxxxxx-xyxy-ttjj-xyxy-xxxxxxxxxxxx'.replace(/[xy]/g, function (c) {
      var r = Math.random() * 16 | 0,
        v = c == 'x' ? r : (r & 0x3 | 0x8);
      return v.toString(16);
    });
    localStorage.setItem("deviceId", str);
    return str;
  }

  transferTxtToEmotion(str) {
    var emotionarr = str.match(reg)
    if (emotionarr) {
      for (let j = 0; j < emotionarr.length; j++) {
        for (var i = 0; i < emotions.length; i++) {
          if (emotionarr[j] === emotions[i].code) {
            str = str.replace(emotionarr[j], `<img src='./static/emotion_qq/${emotions[i].fileName}' class='emotion'/>`);
          }
        }
      }
    }
    return str

    // var match = emotionReg.exec(str);
    // console.log(match)
    // while (match) {
    //     var _emo = match[0];
    //     // console.log(_emo)
    //     for (var i = 0; i < emotions.length; i++) {
    //         if (_emo === emotions[i].code) {
    //             // console.log(100)
    //             str = str.replace(_emo, `<img src='./static/emotion_qq/${emotions[i].fileName}' class='emotion'/>`);
    //         }
    //     }

    //     match = emotionReg.exec(str);
    // }
    // return str
  }

  transferUrlToImg(str, id) {
    var match = urlToImgReg.exec(str);
    var only = onlyImgReg.exec(str)
    onlyImgReg.lastIndex = 0;
    this.imgOnly[id] = !!only;
    while (match) {
        var _m1 = match[1];
        var nowStr = `<img data-url='${_m1}' src='./static/img/loading.gif' width='20'/>`
        str = str.replace(match[0], nowStr);
        urlToImgReg.lastIndex = 0;
        match = urlToImgReg.exec(str);
        Bus.$emit("downloadImg", _m1, nowStr, id);
    }
    return str
  }

  transferUrl(str) {
    var match = hrefLink.exec(str);
    while (match) {
      str = str.replace(match[1], `javascript:gonewpage('${match[1]}')`);
      match = hrefLink.exec(str);
    }
    return str
  }

  onlyHasImg(id) {
    return this.imgOnly[id];
  }

  getMsgType(str, id) {
    var match = urlToLinkAndExt.exec(str)
    if (match) {
      var ext = "." + match[2].split(".").pop()
      var fileIcon = fileTypes[ext.toUpperCase()]
      urlToLinkAndExt.lastIndex = 0;
      if (!fileIcon) {
        return null;
      }
      var _m1 =match[1]
      Bus.$emit("downloadFile", _m1, id);
      return {
        loaded: false,
        url: _m1,
        name: match[2],
        icon: window.configs.baseDir + "/static/img/" + fileIcon
      }
    }
    return null;
  }

  transferWarp(str) {
    return str.replace(/(\r\n)|\r|\n/ig, "<br />")
  }

  /**
   * 获取cookie数据
   * Cookies.get("key")
   * @param key cookie 键名
   */
  getCookie(key) {
    var arr, reg = new RegExp("(^| )" + key + "=([^;]*)(;|$)");
    if (arr = document.cookie.match(reg))
      return arr[2];
    else
      return null;
  }
  /**
   * 设置cookie
   * Cookies.set("key", "value", 100, "/", "example.com")
   * @param key  键
   * @param value  值
   * @param expires  过期时间（单位：天）
   * @param path     目录
   * @param domain   域名
   */
  setCookie(key, value, expires, path, domain) {
    if (expires === void 0) {
      expires = 0;
    }
    if (path === void 0) {
      path = "/";
    }
    if (domain === void 0) {
      domain = "";
    }
    var now = new Date();
    var expiresDate = expires == 0 ? "" : new Date(now.setTime(now.getTime() + expires * 24 * 3600 * 1000)).toString();
    document.cookie = key + "=" + value + "; expires=" + expiresDate + "; path=" + path + ";domain=" + domain;
  }
  /**
   * 删除cookie
   * @param key 键
   */
  delCookie(key) {
    this.setCookie(key, "", -1);
  }

  /**
   * 日期格式化 月(M)、日(d)、12小时(h)、24小时(H)、分(m)、秒(s)、周(E)、季度(q)
   *
   * @param date 时间格式
   * @param fmt 字符串格式
   *
   * Format.dateFormat(new Date(),"yyyy-MM-dd hh:mm:ss 星期e 周E 第q季度 第Q季度")
   *
   * "2017-11-09 02:00:00 星期4 周四 第4季度 第四季度"
   */
  dateFormat(date, fmt) {
    if (date === void 0) {
      date = new Date();
    }
    if (fmt === void 0) {
      fmt = "yyyy-MM-dd";
    }
    if (typeof date == "string") {
      try {
        date = +date;
      } catch (e) {

      }
    }
    if (typeof date == "number") {
      date = new Date(date)
    }
    if (!(date instanceof Date)) {
      date = this.parseDate(date.toString().replace(/-/g, '/'));
    }
    if (date.toString() === "Invalid Date") {
      return "-";
    }
    var num = ["\u65e5", "\u4e00", "\u4e8c", "\u4e09", "\u56db", "\u4e94", "\u516d"]; // 1 ~ 7
    var o = {
      "M+": date.getMonth() + 1,
      "d+": date.getDate(),
      "h+": date.getHours(),
      "H+": date.getHours(),
      "m+": date.getMinutes(),
      "s+": date.getSeconds(),
      "E": num[date.getDay()],
      "e": date.getDay(),
      "q": Math.floor((date.getMonth() + 3) / 3),
      "Q": num[Math.floor((date.getMonth() + 3) / 3)],
      "S": date.getMilliseconds() //毫秒
    };
    if (/(y+)/.test(fmt)) {
      fmt = fmt.replace(RegExp.$1, (date.getFullYear() + "").substr(4 - RegExp.$1.length));
    }
    for (var k in o) {
      if (new RegExp("(" + k + ")").test(fmt)) {
        fmt = fmt.replace(RegExp.$1, (RegExp.$1.length == 1) ? (o[k]) : (("00" + o[k]).substr(("" + o[k]).length)));
      }
    }
    return fmt;
  }
  /**
   * 字符串转日期
   *
   * @param date 日期字符串
   */
  parseDate(date) {
    return typeof date !== "string" ? date : new Date(Date.parse(date.replace(/-/g, "/").replace(/T/g, " ")));
  }


  htmlDecode(str) {
    var s = "";
    if (str.length == 0) return "";
    s = str.replace(/&gt;/g, "&");
    s = s.replace(/&lt;/g, "<");
    s = s.replace(/&gt;/g, ">");
    s = s.replace(/&nbsp;/g, " ");
    s = s.replace(/&#39;/g, "\'");
    s = s.replace(/&quot;/g, "\"");
    s = s.replace(/<br>/g, "\n");
    return s;
  }

  /**
   * input 文件对象转字符串
   */
  fileObjToStr(fileObj, cb) {
    var file = fileObj;
    var reader = new FileReader();
    reader.onloadend = function () {
      cb && cb(reader.result)
    };
    reader.readAsDataURL(file); // 读出 base64
  }

  getImgWidthAndHeight(url, cb) {
    var $img = document.createElement('img');
    $img.onload = () => {
      cb && cb({
        link: url,
        width: $img.naturalWidth,
        height: $img.naturalHeight
      })
      $img = null;
    }
    $img.onerror = () => {
      $img = null;
      cb && cb({})
    }
    $img.src = url;
  }

  /**
   * 频率控制 返回函数连续调用时，fn 执行频率限定为每多少时间执行一次
   * @param fn {function}  需要调用的函数
   * @param delay  {number}    延迟时间，单位毫秒
   * @param immediate  {bool} 给 immediate参数传递false 绑定的函数先执行，而不是delay后后执行。
   * @return {function}实际调用函数
   */
  throttle(fn, delay, immediate, debounce) {
    var curr = +new Date(), //当前事件
      last_call = 0,
      last_exec = 0,
      timer = null,
      diff, //时间差
      context, //上下文
      args,
      exec = function () {
        last_exec = curr;
        fn.apply(context, args);
      };
    return function () {
      curr = +new Date();
      context = this,
        args = arguments,
        diff = curr - (debounce ? last_call : last_exec) - delay;
      clearTimeout(timer);
      if (debounce) {
        if (immediate) {
          timer = setTimeout(exec, delay);
        } else if (diff >= 0) {
          exec();
        }
      } else {
        if (diff >= 0) {
          exec();
        } else if (immediate) {
          timer = setTimeout(exec, -diff);
        }
      }
      last_call = curr;
    }
  }

  /**
   * 空闲控制 返回函数连续调用时，空闲时间必须大于或等于 delay，fn 才会执行
   * @param fn {function}  要调用的函数
   * @param delay   {number}    空闲时间
   * @param immediate  {bool} 给 immediate参数传递false 绑定的函数先执行，而不是delay后后执行。
   * @return {function}实际调用函数
   */

  debounce(fn, delay, immediate) {
    return this.throttle(fn, delay, immediate, true);
  }

  /**
   * 数组快速排序
   * @param {Array} arr 数组
   * @param {String} key 数组内若为对象则可以设置其key
   */

  quickSort (arr = [], key = '') {
    if (arr.length <= 1) { return arr;}
    let pivotIndex = Math.floor(_len / 2);
    let pivot = arr.splice(pivotIndex, 1)[0]
    let _len = arr.length;
    let pivotVal = pivot
    if (key && pivot[key]) { pivotVal = pivot[key] };
    let left = []
    let right = []
    for (let i = 0; i < _len; i++) {
      let curr = arr[i];
      let currVal = arr[i];
      if (key && curr[key]) {
        currVal = curr[key]
      }
      if (currVal > pivotVal) {
        left.push(curr)
      } else {
        right.push(curr)
      }
    }

    return this.quickSort(left, key).concat([pivot], this.quickSort(right, key));
  }
}

export default new Util();



// WEBPACK FOOTER //
// ./src/utils/util.js